export const CUSTOMIZATION_KIND = {
    CutToLength: 1,
    Drill: 2,
    Miter: 3,
    RipCut: 4,
    Tap: 5,
    Bevel: 6,
    CrimpEnd: 7
}

export const FAMILY_MEMBER_KIND = { 
    CutToLengthMaterial: 'CutToLengthMaterial',
    Stick: 'Stick',
    Bundle: 'Bundle',
    AccessoryEndCap: 'End Cap'
}